module.exports = __webpack_public_path__ + "static/media/linkedin_blue.cf646bbe.svg";